module.exports = "//public.zight.com/packs/media/images/icons-invite-active-2275e70848a009a790f2e0854ff875ff.svg";